import {fromJS, Map} from 'immutable';
import returnPlayersActions from '../../actions/fortnite-game/returnPlayers.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {TimeScale} from '../../types';

const DEFAULT_DATA = {
    [TimeScale.DAILY]: {
        list: [],
        empty: []
    }
};

export const DEFAULT_STATE = fromJS({
    data: DEFAULT_DATA,
    timeScale: TimeScale.DAILY,
    error: undefined,
    loading: false
});

export const returnPlayersReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {timeScale, data, silent = false, error} = action.payload || {};

    switch (action.type) {
        case returnPlayersActions.TYPES.GET_RETURN_PLAYERS: {
            return state.merge({
                timeScale,
                error: undefined,
                loading: !silent
            });
        }

        case returnPlayersActions.TYPES.GET_RETURN_PLAYERS_COMPLETE: {
            return state
                .update('data', stateData => stateData.set(state.get('timeScale'), data))
                .merge({
                    lastFetch: Date.now(),
                    loading: false,
                    error
                });
        }

        case returnPlayersActions.TYPES.GET_RETURN_PLAYERS_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        case returnPlayersActions.TYPES.RESET_DATA: {
            return state.merge({
                data: DEFAULT_DATA
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('returnPlayers', returnPlayersReducer);
